export default __webpack_public_path__ + "static/media/kr.82904785.png";